exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Content__content{padding:80px 0;max-width:600px;width:calc(100%-20px);margin:0 auto}@media (max-width:500px){.Content__content{width:100%;padding:70px 20px 80px}}", ""]);

// exports
exports.locals = {
	"content": "Content__content"
};